import { render, staticRenderFns } from "./TaskPanel.vue?vue&type=template&id=a2decb9c&scoped=true"
import script from "./TaskPanel.vue?vue&type=script&lang=js"
export * from "./TaskPanel.vue?vue&type=script&lang=js"
import style0 from "./TaskPanel.vue?vue&type=style&index=0&id=a2decb9c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2decb9c",
  null
  
)

export default component.exports